/** One tick of TransportState position-stall monitor (#999 exclusive branch extracted). */

import { exclusiveStallFrozenMs } from './exclusiveEngineStallReconcile';

export type PositionStallMonitorRefs = {
  lastObservedPosition: number;
  lastPositionChangeAt: number;
  stallReconcileCooldownUntil: number;
};

export type PositionStallMonitorTickInput = {
  refs: PositionStallMonitorRefs;
  playbackState: string;
  position: number;
  exclusiveActive: boolean;
  isNetworkZone: boolean;
  isReconcileDegraded: boolean;
  stallReconcileMs: number;
  nowMs: number;
  onExclusiveStall: (frozenMs: number) => void;
  onNetworkStall: (frozenMs: number) => void;
};

export function tickPositionStallMonitor(input: PositionStallMonitorTickInput): PositionStallMonitorRefs {
  const refs = { ...input.refs };
  const storePos = input.position || 0;

  if (input.exclusiveActive || !input.isNetworkZone) {
    if (!input.exclusiveActive) {
      refs.lastObservedPosition = storePos;
      refs.lastPositionChangeAt = input.nowMs;
      return refs;
    }

    if (input.playbackState !== 'playing' || storePos !== refs.lastObservedPosition) {
      refs.lastObservedPosition = storePos;
      refs.lastPositionChangeAt = input.nowMs;
      return refs;
    }

    const exclusiveFrozenMs = exclusiveStallFrozenMs({
      playbackState: input.playbackState,
      position: storePos,
      lastObservedPosition: refs.lastObservedPosition,
      lastPositionChangeAt: refs.lastPositionChangeAt,
      stallReconcileCooldownUntil: refs.stallReconcileCooldownUntil,
      stallReconcileMs: input.stallReconcileMs,
      nowMs: input.nowMs,
    });
    if (exclusiveFrozenMs != null) {
      input.onExclusiveStall(exclusiveFrozenMs);
    }
    return refs;
  }

  if (input.playbackState !== 'playing') {
    refs.lastObservedPosition = storePos;
    refs.lastPositionChangeAt = input.nowMs;
    return refs;
  }

  if (storePos !== refs.lastObservedPosition) {
    refs.lastObservedPosition = storePos;
    refs.lastPositionChangeAt = input.nowMs;
    return refs;
  }

  const frozenMs = input.nowMs - refs.lastPositionChangeAt;
  if (
    frozenMs >= input.stallReconcileMs
    && input.nowMs >= refs.stallReconcileCooldownUntil
    && !input.isReconcileDegraded
  ) {
    input.onNetworkStall(frozenMs);
  }
  return refs;
}
